export const f_ = [
  {
    "Ticker": "A",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "A",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "A",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "A",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "A",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "A",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "A",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "A",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "A",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "A",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "A",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "A",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "A",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "A",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "A",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "A",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "A",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "A",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "A",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "A",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "A",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "A",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAL",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAL",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAL",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAL",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAL",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAL",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAL",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAL",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAL",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAL",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAL",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAL",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAL",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAL",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAL",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAL",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAL",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAL",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAL",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAL",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAL",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAL",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAP",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAP",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAP",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAP",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAP",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAP",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAP",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAP",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAP",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAP",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAP",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAP",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAP",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAP",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAP",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAP",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAP",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAP",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAP",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAP",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAP",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAP",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAPL",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAPL",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "110M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAPL",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAPL",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAPL",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAPL",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAPL",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAPL",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAPL",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAPL",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAPL",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAPL",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAPL",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAPL",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAPL",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAPL",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAPL",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAPL",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAPL",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAPL",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAPL",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AAPL",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABBV",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABBV",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABBV",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABBV",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABBV",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABBV",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABBV",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABBV",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABBV",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABBV",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABBV",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABBV",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABBV",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABBV",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABBV",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABBV",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABBV",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABBV",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABBV",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABBV",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABBV",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABBV",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABC",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABC",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABC",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABC",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABC",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABC",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABC",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABC",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABC",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABC",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABC",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABC",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABC",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABC",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABC",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABC",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABC",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABC",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABC",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABC",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABC",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABC",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABMD",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABMD",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABMD",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABMD",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABMD",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABMD",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABMD",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABMD",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABMD",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABMD",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABMD",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABMD",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABMD",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABMD",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABMD",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABMD",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABMD",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABMD",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABMD",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABMD",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABMD",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABMD",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABT",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABT",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABT",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABT",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABT",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABT",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABT",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABT",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABT",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABT",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABT",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABT",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABT",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABT",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABT",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABT",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABT",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABT",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABT",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABT",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABT",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ABT",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ACN",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ACN",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ACN",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ACN",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ACN",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ACN",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ACN",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ACN",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ACN",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ACN",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ACN",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ACN",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ACN",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ACN",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ACN",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ACN",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ACN",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ACN",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ACN",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ACN",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ACN",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ACN",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ADBE",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ADBE",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ADBE",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ADBE",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ADBE",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ADBE",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ADBE",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ADBE",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ADBE",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ADBE",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ADBE",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ADBE",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ADBE",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ADBE",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ADBE",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ADBE",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ADBE",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ADBE",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ADBE",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ADBE",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ADBE",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ADBE",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AFL",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AFL",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AFL",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AFL",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AFL",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AFL",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AFL",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AFL",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AFL",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AFL",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AFL",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AFL",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AFL",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AFL",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AFL",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AFL",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AFL",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AFL",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AFL",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AFL",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AFL",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AFL",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AIZ",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AIZ",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AIZ",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AIZ",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AIZ",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AIZ",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AIZ",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AIZ",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AIZ",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AIZ",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AIZ",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AIZ",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AIZ",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AIZ",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AIZ",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AIZ",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AIZ",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AIZ",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AIZ",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AIZ",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AIZ",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AIZ",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AJG",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AJG",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AJG",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AJG",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AJG",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AJG",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AJG",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AJG",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AJG",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AJG",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AJG",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AJG",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AJG",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AJG",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AJG",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AJG",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AJG",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AJG",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AJG",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AJG",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AJG",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AJG",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AKAM",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AKAM",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AKAM",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AKAM",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AKAM",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AKAM",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AKAM",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AKAM",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AKAM",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AKAM",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AKAM",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AKAM",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AKAM",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AKAM",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AKAM",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AKAM",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AKAM",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AKAM",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AKAM",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AKAM",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AKAM",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AKAM",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ALB",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ALB",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ALB",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ALB",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ALB",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ALB",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ALB",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ALB",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ALB",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ALB",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ALB",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ALB",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ALB",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ALB",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ALB",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ALB",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ALB",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ALB",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ALB",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ALB",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ALB",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ALB",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ALLE",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ALLE",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ALLE",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ALLE",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ALLE",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ALLE",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ALLE",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ALLE",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ALLE",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ALLE",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ALLE",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ALLE",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ALLE",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ALLE",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ALLE",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ALLE",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ALLE",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ALLE",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ALLE",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ALLE",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ALLE",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ALLE",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMAT",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMAT",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMAT",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMAT",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMAT",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMAT",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMAT",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMAT",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMAT",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMAT",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMAT",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMAT",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMAT",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMAT",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMAT",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMAT",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMAT",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMAT",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMAT",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMAT",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMAT",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMAT",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AME",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AME",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AME",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AME",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AME",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AME",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AME",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AME",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AME",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AME",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AME",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AME",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AME",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AME",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AME",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AME",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AME",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AME",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AME",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AME",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AME",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AME",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMP",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMP",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMP",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMP",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMP",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMP",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMP",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMP",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMP",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMP",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMP",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMP",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMP",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMP",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMP",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMP",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMP",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMP",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMP",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMP",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMP",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMP",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMZN",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMZN",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMZN",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMZN",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMZN",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMZN",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMZN",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMZN",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMZN",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMZN",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMZN",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMZN",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMZN",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMZN",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMZN",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMZN",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMZN",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMZN",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMZN",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMZN",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMZN",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AMZN",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ANET",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ANET",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ANET",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ANET",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ANET",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ANET",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ANET",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ANET",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ANET",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ANET",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ANET",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ANET",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ANET",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ANET",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ANET",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ANET",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ANET",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ANET",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ANET",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ANET",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ANET",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ANET",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ANSS",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ANSS",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ANSS",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ANSS",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ANSS",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ANSS",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ANSS",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ANSS",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ANSS",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ANSS",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ANSS",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ANSS",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ANSS",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ANSS",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ANSS",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ANSS",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ANSS",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ANSS",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ANSS",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ANSS",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ANSS",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ANSS",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "APTV",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "APTV",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "APTV",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "APTV",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "APTV",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "APTV",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "APTV",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "APTV",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "APTV",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "APTV",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "APTV",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "APTV",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "APTV",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "APTV",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "APTV",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "APTV",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "APTV",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "APTV",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "APTV",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "APTV",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "APTV",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "APTV",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ARE",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ARE",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ARE",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ARE",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ARE",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ARE",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ARE",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ARE",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ARE",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ARE",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ARE",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ARE",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ARE",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ARE",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ARE",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ARE",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ARE",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ARE",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ARE",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ARE",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ARE",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ARE",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ATVI",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ATVI",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ATVI",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ATVI",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ATVI",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ATVI",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ATVI",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ATVI",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ATVI",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ATVI",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ATVI",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ATVI",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ATVI",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ATVI",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ATVI",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ATVI",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ATVI",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ATVI",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ATVI",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ATVI",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ATVI",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ATVI",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AZO",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AZO",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AZO",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AZO",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AZO",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AZO",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AZO",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AZO",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AZO",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AZO",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AZO",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AZO",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AZO",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AZO",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AZO",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AZO",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AZO",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AZO",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AZO",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AZO",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AZO",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "AZO",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BA",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BA",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BA",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BA",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BA",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BA",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BA",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BA",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BA",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BA",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BA",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BA",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BA",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BA",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BA",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BA",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BA",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BA",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BA",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BA",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BA",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BA",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BAC",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BAC",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BAC",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BAC",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BAC",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BAC",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BAC",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BAC",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BAC",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BAC",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BAC",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BAC",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BAC",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BAC",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BAC",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BAC",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BAC",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BAC",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BAC",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BAC",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BAC",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BAC",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BBY",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BBY",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BBY",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BBY",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BBY",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BBY",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BBY",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BBY",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BBY",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BBY",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BBY",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BBY",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BBY",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BBY",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BBY",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BBY",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BBY",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BBY",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BBY",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BBY",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BBY",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BBY",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BDX",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BDX",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BDX",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BDX",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BDX",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BDX",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BDX",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BDX",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BDX",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BDX",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BDX",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BDX",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BDX",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BDX",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BDX",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BDX",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BDX",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BDX",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BDX",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BDX",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BDX",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BDX",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BEN",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BEN",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BEN",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BEN",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BEN",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BEN",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BEN",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BEN",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BEN",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BEN",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BEN",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BEN",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BEN",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BEN",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BEN",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BEN",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BEN",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BEN",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BEN",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BEN",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BEN",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BEN",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BIIB",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BIIB",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BIIB",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BIIB",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BIIB",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BIIB",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BIIB",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BIIB",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BIIB",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BIIB",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BIIB",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BIIB",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BIIB",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BIIB",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BIIB",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BIIB",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BIIB",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BIIB",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BIIB",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BIIB",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BIIB",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BIIB",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BIO",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BIO",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BIO",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BIO",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BIO",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BIO",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BIO",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BIO",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BIO",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BIO",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BIO",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BIO",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BIO",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BIO",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BIO",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BIO",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BIO",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BIO",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BIO",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BIO",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BIO",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BIO",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BMY",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BMY",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BMY",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BMY",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BMY",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BMY",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BMY",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BMY",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BMY",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BMY",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BMY",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BMY",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BMY",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BMY",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BMY",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BMY",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BMY",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BMY",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BMY",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BMY",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BMY",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BMY",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BRK-B",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BRK-B",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BRK-B",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BRK-B",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BRK-B",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BRK-B",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BRK-B",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BRK-B",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BRK-B",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BRK-B",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BRK-B",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BRK-B",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BRK-B",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BRK-B",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BRK-B",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BRK-B",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BRK-B",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BRK-B",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BRK-B",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BRK-B",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BRK-B",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BRK-B",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BWA",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BWA",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BWA",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BWA",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BWA",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BWA",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BWA",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BWA",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BWA",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BWA",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BWA",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BWA",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BWA",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BWA",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BWA",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BWA",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BWA",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BWA",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BWA",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BWA",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BWA",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "BWA",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "C",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "C",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "C",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "C",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "C",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "C",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "C",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "C",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "C",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "C",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "C",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "C",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "C",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "C",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "C",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "C",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "C",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "C",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "C",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "C",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "C",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "C",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CAT",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CAT",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CAT",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CAT",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CAT",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CAT",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CAT",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CAT",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CAT",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CAT",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CAT",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CAT",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CAT",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CAT",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CAT",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CAT",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CAT",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CAT",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CAT",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CAT",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CAT",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CAT",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CCI",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CCI",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CCI",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CCI",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CCI",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CCI",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CCI",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CCI",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CCI",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CCI",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CCI",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CCI",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CCI",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CCI",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CCI",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CCI",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CCI",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CCI",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CCI",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CCI",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CCI",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CCI",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CDAY",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CDAY",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CDAY",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CDAY",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CDAY",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CDAY",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CDAY",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CDAY",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CDAY",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CDAY",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CDAY",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CDAY",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CDAY",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CDAY",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CDAY",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CDAY",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CDAY",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CDAY",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CDAY",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CDAY",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CDAY",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CDAY",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CHTR",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CHTR",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CHTR",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CHTR",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CHTR",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CHTR",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CHTR",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CHTR",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CHTR",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CHTR",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CHTR",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CHTR",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CHTR",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CHTR",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CHTR",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CHTR",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CHTR",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CHTR",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CHTR",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CHTR",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CHTR",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CHTR",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CMA",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CMA",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CMA",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CMA",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CMA",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CMA",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CMA",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CMA",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CMA",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CMA",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CMA",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CMA",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CMA",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CMA",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CMA",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CMA",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CMA",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CMA",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CMA",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CMA",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CMA",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CMA",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CMCSA",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CMCSA",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CMCSA",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CMCSA",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CMCSA",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CMCSA",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CMCSA",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CMCSA",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CMCSA",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CMCSA",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CMCSA",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CMCSA",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CMCSA",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CMCSA",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CMCSA",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CMCSA",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CMCSA",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CMCSA",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CMCSA",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CMCSA",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CMCSA",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CMCSA",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CME",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CME",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CME",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CME",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CME",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CME",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CME",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CME",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CME",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CME",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CME",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CME",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CME",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CME",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CME",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CME",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CME",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CME",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CME",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CME",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CME",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CME",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CNC",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CNC",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CNC",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CNC",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CNC",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CNC",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CNC",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CNC",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CNC",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CNC",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CNC",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CNC",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CNC",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CNC",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CNC",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CNC",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CNC",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CNC",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CNC",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CNC",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CNC",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CNC",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "COO",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "COO",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "COO",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "COO",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "COO",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "COO",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "COO",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "COO",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "COO",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "COO",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "COO",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "COO",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "COO",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "COO",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "COO",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "COO",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "COO",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "COO",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "COO",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "COO",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "COO",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "COO",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CRL",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CRL",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CRL",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CRL",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CRL",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CRL",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CRL",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CRL",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CRL",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CRL",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CRL",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CRL",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CRL",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CRL",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CRL",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CRL",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CRL",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CRL",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CRL",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CRL",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CRL",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CRL",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CTLT",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CTLT",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CTLT",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CTLT",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CTLT",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CTLT",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CTLT",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CTLT",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CTLT",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CTLT",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CTLT",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CTLT",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CTLT",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CTLT",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CTLT",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CTLT",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CTLT",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CTLT",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CTLT",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CTLT",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CTLT",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CTLT",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CVS",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CVS",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CVS",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CVS",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CVS",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CVS",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CVS",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CVS",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CVS",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CVS",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CVS",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CVS",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CVS",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CVS",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CVS",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CVS",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CVS",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CVS",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CVS",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CVS",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CVS",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "CVS",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DD",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DD",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DD",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DD",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DD",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DD",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DD",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DD",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DD",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DD",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DD",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DD",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DD",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DD",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DD",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DD",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DD",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DD",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DD",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DD",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DD",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DD",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DLR",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DLR",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DLR",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DLR",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DLR",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DLR",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DLR",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DLR",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DLR",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DLR",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DLR",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DLR",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DLR",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DLR",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DLR",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DLR",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DLR",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DLR",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DLR",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DLR",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DLR",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DLR",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DOW",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DOW",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DOW",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DOW",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DOW",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DOW",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DOW",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DOW",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DOW",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DOW",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DOW",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DOW",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DOW",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DOW",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DOW",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DOW",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DOW",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DOW",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DOW",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DOW",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DOW",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DOW",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DPZ",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DPZ",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DPZ",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DPZ",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DPZ",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DPZ",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DPZ",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DPZ",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DPZ",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DPZ",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DPZ",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DPZ",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DPZ",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DPZ",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DPZ",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DPZ",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DPZ",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DPZ",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DPZ",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DPZ",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DPZ",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "DPZ",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ECL",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ECL",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ECL",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ECL",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ECL",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ECL",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ECL",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ECL",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ECL",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ECL",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ECL",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ECL",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ECL",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ECL",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ECL",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ECL",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ECL",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ECL",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ECL",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ECL",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ECL",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ECL",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EFX",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EFX",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EFX",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EFX",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EFX",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EFX",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EFX",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EFX",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EFX",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EFX",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EFX",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EFX",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EFX",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EFX",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EFX",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EFX",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EFX",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EFX",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EFX",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EFX",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EFX",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EFX",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EL",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EL",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EL",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EL",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EL",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EL",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EL",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EL",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EL",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EL",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EL",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EL",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EL",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EL",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EL",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EL",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EL",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EL",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EL",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EL",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EL",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EL",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EXPD",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EXPD",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EXPD",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EXPD",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EXPD",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EXPD",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EXPD",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EXPD",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EXPD",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EXPD",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EXPD",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EXPD",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EXPD",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EXPD",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EXPD",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EXPD",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EXPD",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EXPD",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EXPD",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EXPD",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EXPD",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "EXPD",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FAST",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FAST",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FAST",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FAST",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FAST",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FAST",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FAST",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FAST",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FAST",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FAST",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FAST",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FAST",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FAST",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FAST",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FAST",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FAST",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FAST",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FAST",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FAST",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FAST",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FAST",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FAST",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FB",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FB",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FB",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FB",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FB",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FB",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FB",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FB",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FB",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FB",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FB",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FB",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FB",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FB",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FB",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FB",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FB",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FB",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FB",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FB",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FB",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FB",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FDX",
    "Description": "researchDevelopment",
    "Values": ["117M", "109M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FDX",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FDX",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FDX",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FDX",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FDX",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FDX",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FDX",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FDX",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FDX",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FDX",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FDX",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FDX",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FDX",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FDX",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FDX",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FDX",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FDX",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FDX",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FDX",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FDX",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FDX",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FLT",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FLT",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FLT",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FLT",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FLT",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FLT",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FLT",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FLT",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FLT",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FLT",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FLT",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FLT",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FLT",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FLT",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FLT",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FLT",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FLT",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FLT",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FLT",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FLT",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FLT",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FLT",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FRC",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FRC",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FRC",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FRC",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FRC",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FRC",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FRC",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FRC",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FRC",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FRC",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FRC",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FRC",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FRC",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FRC",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FRC",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FRC",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FRC",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FRC",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FRC",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FRC",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FRC",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "FRC",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GILD",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GILD",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GILD",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GILD",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GILD",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GILD",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GILD",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GILD",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GILD",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GILD",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GILD",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GILD",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GILD",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GILD",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GILD",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GILD",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GILD",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GILD",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GILD",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GILD",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GILD",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GILD",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GL",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GL",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GL",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GL",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GL",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GL",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GL",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GL",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GL",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GL",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GL",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GL",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GL",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GL",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GL",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GL",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GL",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GL",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GL",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GL",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GL",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GL",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GOOGL",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GOOGL",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GOOGL",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GOOGL",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GOOGL",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GOOGL",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GOOGL",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GOOGL",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GOOGL",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GOOGL",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GOOGL",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GOOGL",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GOOGL",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GOOGL",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GOOGL",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GOOGL",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GOOGL",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GOOGL",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GOOGL",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GOOGL",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GOOGL",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "GOOGL",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HON",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HON",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HON",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HON",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HON",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HON",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HON",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HON",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HON",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HON",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HON",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HON",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HON",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HON",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HON",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HON",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HON",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HON",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HON",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HON",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HON",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HON",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HPQ",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HPQ",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HPQ",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HPQ",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HPQ",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HPQ",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HPQ",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HPQ",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HPQ",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HPQ",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HPQ",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HPQ",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HPQ",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HPQ",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HPQ",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HPQ",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HPQ",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HPQ",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HPQ",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HPQ",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HPQ",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HPQ",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HSY",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HSY",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HSY",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HSY",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HSY",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HSY",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HSY",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HSY",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HSY",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HSY",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HSY",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HSY",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HSY",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HSY",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HSY",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HSY",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HSY",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HSY",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HSY",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HSY",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HSY",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "HSY",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IBM",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IBM",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IBM",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IBM",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IBM",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IBM",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IBM",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IBM",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IBM",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IBM",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IBM",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IBM",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IBM",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IBM",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IBM",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IBM",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IBM",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IBM",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IBM",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IBM",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IBM",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IBM",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ICE",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ICE",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ICE",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ICE",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ICE",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ICE",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ICE",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ICE",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ICE",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ICE",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ICE",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ICE",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ICE",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ICE",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ICE",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ICE",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ICE",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ICE",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ICE",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ICE",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ICE",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ICE",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IDXX",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IDXX",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IDXX",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IDXX",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IDXX",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IDXX",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IDXX",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IDXX",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IDXX",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IDXX",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IDXX",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IDXX",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IDXX",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IDXX",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IDXX",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IDXX",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IDXX",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IDXX",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IDXX",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IDXX",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IDXX",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IDXX",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ILMN",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ILMN",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ILMN",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ILMN",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ILMN",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ILMN",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ILMN",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ILMN",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ILMN",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ILMN",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ILMN",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ILMN",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ILMN",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ILMN",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ILMN",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ILMN",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ILMN",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ILMN",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ILMN",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ILMN",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ILMN",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ILMN",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IQV",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IQV",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IQV",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IQV",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IQV",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IQV",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IQV",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IQV",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IQV",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IQV",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IQV",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IQV",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IQV",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IQV",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IQV",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IQV",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IQV",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IQV",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IQV",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IQV",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IQV",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IQV",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IR",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IR",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IR",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IR",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IR",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IR",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IR",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IR",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IR",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IR",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IR",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IR",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IR",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IR",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IR",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IR",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IR",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IR",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IR",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IR",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IR",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "IR",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "JCI",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "JCI",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "JCI",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "JCI",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "JCI",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "JCI",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "JCI",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "JCI",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "JCI",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "JCI",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "JCI",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "JCI",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "JCI",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "JCI",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "JCI",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "JCI",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "JCI",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "JCI",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "JCI",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "JCI",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "JCI",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "JCI",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "JKHY",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "JKHY",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "JKHY",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "JKHY",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "JKHY",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "JKHY",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "JKHY",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "JKHY",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "JKHY",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "JKHY",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "JKHY",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "JKHY",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "JKHY",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "JKHY",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "JKHY",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "JKHY",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "JKHY",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "JKHY",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "JKHY",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "JKHY",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "JKHY",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "JKHY",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "L",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "L",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "L",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "L",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "L",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "L",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "L",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "L",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "L",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "L",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "L",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "L",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "L",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "L",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "L",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "L",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "L",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "L",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "L",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "L",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "L",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "L",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LNT",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LNT",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LNT",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LNT",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LNT",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LNT",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LNT",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LNT",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LNT",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LNT",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LNT",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LNT",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LNT",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LNT",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LNT",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LNT",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LNT",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LNT",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LNT",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LNT",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LNT",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LNT",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LOW",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LOW",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LOW",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LOW",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LOW",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LOW",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LOW",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LOW",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LOW",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LOW",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LOW",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LOW",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LOW",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LOW",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LOW",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LOW",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LOW",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LOW",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LOW",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LOW",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LOW",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LOW",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LUMN",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LUMN",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LUMN",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LUMN",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LUMN",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LUMN",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LUMN",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LUMN",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LUMN",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LUMN",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LUMN",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LUMN",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LUMN",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LUMN",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LUMN",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LUMN",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LUMN",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LUMN",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LUMN",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LUMN",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LUMN",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LUMN",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LUV",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LUV",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LUV",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LUV",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LUV",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LUV",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LUV",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LUV",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LUV",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LUV",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LUV",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LUV",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LUV",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LUV",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LUV",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LUV",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LUV",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LUV",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LUV",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LUV",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LUV",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LUV",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LYB",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LYB",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LYB",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LYB",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LYB",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LYB",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LYB",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LYB",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LYB",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LYB",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LYB",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LYB",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LYB",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LYB",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LYB",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LYB",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LYB",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LYB",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LYB",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LYB",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LYB",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "LYB",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MAA",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MAA",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MAA",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MAA",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MAA",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MAA",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MAA",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MAA",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MAA",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MAA",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MAA",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MAA",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MAA",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MAA",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MAA",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MAA",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MAA",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MAA",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MAA",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MAA",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MAA",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MAA",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MAS",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MAS",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MAS",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MAS",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MAS",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MAS",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MAS",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MAS",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MAS",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MAS",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MAS",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MAS",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MAS",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MAS",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MAS",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MAS",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MAS",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MAS",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MAS",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MAS",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MAS",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MAS",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCD",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCD",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCD",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCD",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCD",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCD",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCD",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCD",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCD",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCD",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCD",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCD",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCD",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCD",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCD",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCD",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCD",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCD",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCD",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCD",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCD",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCD",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCHP",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCHP",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCHP",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCHP",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCHP",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCHP",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCHP",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCHP",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCHP",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCHP",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCHP",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCHP",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCHP",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCHP",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCHP",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCHP",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCHP",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCHP",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCHP",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCHP",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCHP",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCHP",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCO",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCO",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCO",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCO",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCO",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCO",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCO",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCO",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCO",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCO",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCO",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCO",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCO",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCO",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCO",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCO",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCO",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCO",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCO",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCO",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCO",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MCO",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MDT",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MDT",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MDT",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MDT",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MDT",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MDT",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MDT",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MDT",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MDT",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MDT",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MDT",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MDT",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MDT",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MDT",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MDT",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MDT",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MDT",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MDT",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MDT",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MDT",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MDT",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MDT",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MGM",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MGM",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MGM",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MGM",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MGM",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MGM",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MGM",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MGM",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MGM",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MGM",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MGM",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MGM",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MGM",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MGM",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MGM",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MGM",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MGM",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MGM",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MGM",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MGM",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MGM",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MGM",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MMC",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MMC",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MMC",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MMC",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MMC",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MMC",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MMC",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MMC",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MMC",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MMC",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MMC",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MMC",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MMC",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MMC",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MMC",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MMC",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MMC",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MMC",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MMC",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MMC",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MMC",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MMC",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MPWR",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MPWR",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MPWR",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MPWR",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MPWR",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MPWR",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MPWR",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MPWR",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MPWR",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MPWR",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MPWR",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MPWR",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MPWR",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MPWR",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MPWR",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MPWR",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MPWR",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MPWR",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MPWR",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MPWR",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MPWR",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MPWR",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRK",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRK",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRK",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRK",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRK",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRK",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRK",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRK",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRK",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRK",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRK",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRK",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRK",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRK",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRK",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRK",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRK",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRK",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRK",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRK",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRK",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRK",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRNA",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRNA",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRNA",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRNA",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRNA",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRNA",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRNA",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRNA",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRNA",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRNA",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRNA",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRNA",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRNA",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRNA",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRNA",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRNA",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRNA",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRNA",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRNA",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRNA",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRNA",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRNA",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRO",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRO",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRO",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRO",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRO",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRO",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRO",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRO",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRO",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRO",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRO",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRO",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRO",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRO",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRO",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRO",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRO",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRO",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRO",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRO",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRO",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MRO",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MTD",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MTD",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MTD",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MTD",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MTD",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MTD",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MTD",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MTD",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MTD",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MTD",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MTD",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MTD",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MTD",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MTD",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MTD",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MTD",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MTD",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MTD",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MTD",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MTD",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MTD",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "MTD",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NCLH",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NCLH",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NCLH",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NCLH",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NCLH",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NCLH",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NCLH",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NCLH",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NCLH",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NCLH",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NCLH",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NCLH",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NCLH",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NCLH",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NCLH",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NCLH",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NCLH",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NCLH",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NCLH",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NCLH",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NCLH",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NCLH",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NDAQ",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NDAQ",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NDAQ",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NDAQ",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NDAQ",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NDAQ",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NDAQ",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NDAQ",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NDAQ",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NDAQ",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NDAQ",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NDAQ",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NDAQ",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NDAQ",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NDAQ",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NDAQ",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NDAQ",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NDAQ",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NDAQ",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NDAQ",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NDAQ",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NDAQ",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NFLX",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NFLX",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NFLX",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NFLX",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NFLX",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NFLX",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NFLX",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NFLX",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NFLX",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NFLX",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NFLX",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NFLX",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NFLX",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NFLX",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NFLX",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NFLX",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NFLX",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NFLX",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NFLX",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NFLX",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NFLX",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NFLX",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NLOK",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NLOK",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NLOK",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NLOK",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NLOK",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NLOK",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NLOK",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NLOK",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NLOK",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NLOK",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NLOK",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NLOK",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NLOK",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NLOK",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NLOK",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NLOK",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NLOK",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NLOK",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NLOK",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NLOK",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NLOK",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NLOK",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NRG",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NRG",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NRG",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NRG",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NRG",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NRG",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NRG",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NRG",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NRG",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NRG",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NRG",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NRG",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NRG",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NRG",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NRG",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NRG",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NRG",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NRG",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NRG",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NRG",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NRG",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NRG",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NSC",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NSC",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NSC",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NSC",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NSC",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NSC",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NSC",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NSC",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NSC",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NSC",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NSC",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NSC",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NSC",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NSC",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NSC",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NSC",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NSC",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NSC",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NSC",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NSC",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NSC",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NSC",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NVDA",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NVDA",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NVDA",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NVDA",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NVDA",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NVDA",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NVDA",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NVDA",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NVDA",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NVDA",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NVDA",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NVDA",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NVDA",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NVDA",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NVDA",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NVDA",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NVDA",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NVDA",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NVDA",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NVDA",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NVDA",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NVDA",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NWSA",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NWSA",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NWSA",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NWSA",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NWSA",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NWSA",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NWSA",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NWSA",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NWSA",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NWSA",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NWSA",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NWSA",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NWSA",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NWSA",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NWSA",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NWSA",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NWSA",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NWSA",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NWSA",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NWSA",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NWSA",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "NWSA",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "OGN",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "OGN",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "OGN",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "OGN",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "OGN",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "OGN",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "OGN",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "OGN",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "OGN",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "OGN",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "OGN",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "OGN",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "OGN",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "OGN",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "OGN",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "OGN",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "OGN",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "OGN",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "OGN",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "OGN",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "OGN",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "OGN",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ORCL",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ORCL",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ORCL",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ORCL",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ORCL",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ORCL",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ORCL",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ORCL",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ORCL",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ORCL",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ORCL",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ORCL",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ORCL",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ORCL",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ORCL",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ORCL",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ORCL",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ORCL",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ORCL",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ORCL",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ORCL",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ORCL",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PEP",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PEP",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PEP",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PEP",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PEP",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PEP",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PEP",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PEP",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PEP",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PEP",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PEP",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PEP",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PEP",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PEP",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PEP",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PEP",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PEP",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PEP",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PEP",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PEP",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PEP",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PEP",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PFG",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PFG",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PFG",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PFG",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PFG",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PFG",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PFG",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PFG",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PFG",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PFG",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PFG",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PFG",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PFG",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PFG",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PFG",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PFG",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PFG",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PFG",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PFG",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PFG",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PFG",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PFG",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PG",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PG",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PG",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PG",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PG",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PG",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PG",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PG",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PG",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PG",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PG",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PG",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PG",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PG",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PG",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PG",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PG",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PG",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PG",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PG",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PG",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PG",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PGR",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PGR",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PGR",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PGR",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PGR",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PGR",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PGR",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PGR",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PGR",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PGR",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PGR",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PGR",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PGR",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PGR",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PGR",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PGR",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PGR",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PGR",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PGR",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PGR",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PGR",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PGR",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PLD",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PLD",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PLD",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PLD",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PLD",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PLD",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PLD",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PLD",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PLD",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PLD",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PLD",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PLD",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PLD",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PLD",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PLD",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PLD",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PLD",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PLD",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PLD",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PLD",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PLD",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PLD",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PNR",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PNR",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PNR",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PNR",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PNR",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PNR",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PNR",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PNR",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PNR",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PNR",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PNR",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PNR",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PNR",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PNR",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PNR",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PNR",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PNR",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PNR",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PNR",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PNR",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PNR",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PNR",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PPL",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PPL",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PPL",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PPL",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PPL",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PPL",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PPL",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PPL",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PPL",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PPL",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PPL",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PPL",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PPL",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PPL",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PPL",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PPL",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PPL",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PPL",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PPL",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PPL",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PPL",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "PPL",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RCL",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RCL",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RCL",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RCL",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RCL",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RCL",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RCL",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RCL",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RCL",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RCL",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RCL",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RCL",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RCL",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RCL",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RCL",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RCL",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RCL",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RCL",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RCL",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RCL",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RCL",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RCL",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RE",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RE",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RE",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RE",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RE",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RE",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RE",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RE",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RE",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RE",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RE",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RE",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RE",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RE",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RE",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RE",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RE",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RE",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RE",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RE",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RE",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RE",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RHI",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RHI",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RHI",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RHI",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RHI",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RHI",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RHI",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RHI",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RHI",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RHI",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RHI",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RHI",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RHI",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RHI",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RHI",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RHI",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RHI",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RHI",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RHI",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RHI",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RHI",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RHI",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RJF",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RJF",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RJF",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RJF",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RJF",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RJF",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RJF",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RJF",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RJF",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RJF",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RJF",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RJF",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RJF",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RJF",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RJF",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RJF",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RJF",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RJF",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RJF",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RJF",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RJF",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RJF",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RL",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RL",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RL",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RL",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RL",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RL",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RL",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RL",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RL",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RL",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RL",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RL",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RL",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RL",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RL",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RL",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RL",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RL",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RL",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RL",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RL",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RL",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RMD",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RMD",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RMD",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RMD",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RMD",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RMD",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RMD",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RMD",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RMD",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RMD",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RMD",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RMD",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RMD",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RMD",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RMD",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RMD",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RMD",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RMD",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RMD",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RMD",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RMD",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "RMD",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ROL",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ROL",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ROL",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ROL",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ROL",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ROL",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ROL",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ROL",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ROL",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ROL",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ROL",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ROL",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ROL",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ROL",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ROL",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ROL",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ROL",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ROL",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ROL",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ROL",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ROL",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ROL",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ROP",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ROP",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ROP",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ROP",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ROP",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ROP",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ROP",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ROP",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ROP",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ROP",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ROP",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ROP",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ROP",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ROP",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ROP",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ROP",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ROP",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ROP",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ROP",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ROP",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ROP",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ROP",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SBNY",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SBNY",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SBNY",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SBNY",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SBNY",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SBNY",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SBNY",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SBNY",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SBNY",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SBNY",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SBNY",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SBNY",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SBNY",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SBNY",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SBNY",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SBNY",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SBNY",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SBNY",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SBNY",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SBNY",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SBNY",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SBNY",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SEDG",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SEDG",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SEDG",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SEDG",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SEDG",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SEDG",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SEDG",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SEDG",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SEDG",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SEDG",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SEDG",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SEDG",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SEDG",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SEDG",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SEDG",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SEDG",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SEDG",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SEDG",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SEDG",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SEDG",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SEDG",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SEDG",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SJM",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SJM",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SJM",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SJM",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SJM",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SJM",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SJM",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SJM",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SJM",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SJM",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SJM",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SJM",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SJM",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SJM",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SJM",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SJM",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SJM",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SJM",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SJM",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SJM",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SJM",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SJM",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "STT",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "STT",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "STT",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "STT",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "STT",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "STT",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "STT",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "STT",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "STT",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "STT",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "STT",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "STT",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "STT",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "STT",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "STT",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "STT",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "STT",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "STT",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "STT",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "STT",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "STT",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "STT",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SYF",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SYF",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SYF",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SYF",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SYF",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SYF",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SYF",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SYF",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SYF",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SYF",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SYF",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SYF",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SYF",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SYF",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SYF",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SYF",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SYF",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SYF",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SYF",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SYF",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SYF",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "SYF",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TAP",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TAP",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TAP",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TAP",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TAP",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TAP",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TAP",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TAP",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TAP",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TAP",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TAP",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TAP",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TAP",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TAP",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TAP",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TAP",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TAP",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TAP",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TAP",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TAP",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TAP",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TAP",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TMUS",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TMUS",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TMUS",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TMUS",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TMUS",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TMUS",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TMUS",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TMUS",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TMUS",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TMUS",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TMUS",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TMUS",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TMUS",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TMUS",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TMUS",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TMUS",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TMUS",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TMUS",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TMUS",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TMUS",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TMUS",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TMUS",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TPR",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TPR",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TPR",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TPR",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TPR",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TPR",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TPR",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TPR",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TPR",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TPR",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TPR",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TPR",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TPR",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TPR",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TPR",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TPR",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TPR",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TPR",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TPR",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TPR",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TPR",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TPR",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TRMB",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TRMB",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TRMB",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TRMB",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TRMB",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TRMB",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TRMB",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TRMB",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TRMB",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TRMB",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TRMB",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TRMB",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TRMB",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TRMB",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TRMB",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TRMB",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TRMB",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TRMB",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TRMB",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TRMB",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TRMB",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TRMB",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TRV",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TRV",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TRV",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TRV",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TRV",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TRV",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TRV",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TRV",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TRV",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TRV",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TRV",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TRV",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TRV",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TRV",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TRV",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TRV",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TRV",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TRV",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TRV",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TRV",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TRV",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TRV",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TSN",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TSN",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TSN",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TSN",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TSN",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TSN",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TSN",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TSN",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TSN",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TSN",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TSN",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TSN",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TSN",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TSN",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TSN",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TSN",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TSN",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TSN",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TSN",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TSN",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TSN",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TSN",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TWTR",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TWTR",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TWTR",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TWTR",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TWTR",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TWTR",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TWTR",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TWTR",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TWTR",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TWTR",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TWTR",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TWTR",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TWTR",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TWTR",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TWTR",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TWTR",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TWTR",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TWTR",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TWTR",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TWTR",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TWTR",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TWTR",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TXT",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TXT",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TXT",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TXT",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TXT",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TXT",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TXT",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TXT",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TXT",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TXT",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TXT",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TXT",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TXT",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TXT",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TXT",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TXT",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TXT",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TXT",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TXT",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TXT",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TXT",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "TXT",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UNH",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UNH",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UNH",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UNH",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UNH",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UNH",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UNH",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UNH",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UNH",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UNH",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UNH",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UNH",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UNH",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UNH",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UNH",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UNH",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UNH",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UNH",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UNH",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UNH",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UNH",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UNH",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UNP",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UNP",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UNP",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UNP",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UNP",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UNP",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UNP",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UNP",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UNP",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UNP",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UNP",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UNP",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UNP",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UNP",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UNP",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UNP",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UNP",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UNP",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UNP",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UNP",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UNP",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UNP",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UPS",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UPS",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UPS",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UPS",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UPS",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UPS",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UPS",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UPS",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UPS",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UPS",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UPS",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UPS",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UPS",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UPS",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UPS",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UPS",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UPS",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UPS",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UPS",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UPS",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UPS",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "UPS",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "USB",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "USB",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "USB",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "USB",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "USB",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "USB",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "USB",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "USB",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "USB",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "USB",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "USB",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "USB",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "USB",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "USB",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "USB",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "USB",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "USB",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "USB",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "USB",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "USB",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "USB",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "USB",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VRSK",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VRSK",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VRSK",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VRSK",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VRSK",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VRSK",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VRSK",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VRSK",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VRSK",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VRSK",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VRSK",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VRSK",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VRSK",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VRSK",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VRSK",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VRSK",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VRSK",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VRSK",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VRSK",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VRSK",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VRSK",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VRSK",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VTR",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VTR",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VTR",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VTR",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VTR",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VTR",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VTR",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VTR",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VTR",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VTR",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VTR",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VTR",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VTR",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VTR",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VTR",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VTR",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VTR",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VTR",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VTR",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VTR",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VTR",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VTR",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VZ",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VZ",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VZ",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VZ",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VZ",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VZ",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VZ",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VZ",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VZ",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VZ",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VZ",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VZ",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VZ",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VZ",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VZ",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VZ",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VZ",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VZ",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VZ",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VZ",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VZ",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "VZ",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WAT",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WAT",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WAT",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WAT",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WAT",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WAT",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WAT",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WAT",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WAT",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WAT",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WAT",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WAT",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WAT",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WAT",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WAT",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WAT",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WAT",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WAT",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WAT",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WAT",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WAT",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WAT",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WDC",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WDC",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WDC",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WDC",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WDC",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WDC",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WDC",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WDC",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WDC",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WDC",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WDC",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WDC",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WDC",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WDC",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WDC",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WDC",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WDC",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WDC",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WDC",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WDC",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WDC",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WDC",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WEC",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WEC",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WEC",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WEC",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WEC",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WEC",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WEC",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WEC",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WEC",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WEC",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WEC",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WEC",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WEC",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WEC",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WEC",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WEC",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WEC",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WEC",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WEC",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WEC",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WEC",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WEC",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WELL",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WELL",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WELL",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WELL",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WELL",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WELL",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WELL",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WELL",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WELL",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WELL",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WELL",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WELL",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WELL",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WELL",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WELL",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WELL",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WELL",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WELL",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WELL",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WELL",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WELL",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "WELL",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "XOM",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "XOM",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "XOM",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "XOM",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "XOM",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "XOM",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "XOM",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "XOM",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "XOM",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "XOM",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "XOM",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "XOM",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "XOM",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "XOM",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "XOM",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "XOM",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "XOM",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "XOM",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "XOM",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "XOM",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "XOM",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "XOM",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "XYL",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "XYL",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "XYL",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "XYL",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "XYL",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "XYL",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "XYL",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "XYL",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "XYL",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "XYL",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "XYL",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "XYL",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "XYL",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "XYL",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "XYL",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "XYL",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "XYL",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "XYL",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "XYL",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "XYL",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "XYL",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "XYL",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "YUM",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "YUM",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "YUM",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "YUM",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "YUM",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "YUM",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "YUM",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "YUM",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "YUM",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "YUM",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "YUM",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "YUM",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "YUM",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "YUM",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "YUM",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "YUM",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "YUM",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "YUM",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "YUM",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "YUM",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "YUM",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "YUM",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ZBH",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ZBH",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ZBH",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ZBH",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ZBH",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ZBH",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ZBH",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ZBH",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ZBH",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ZBH",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ZBH",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ZBH",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ZBH",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ZBH",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ZBH",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ZBH",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ZBH",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ZBH",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ZBH",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ZBH",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ZBH",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ZBH",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ZBRA",
    "Description": "researchDevelopment",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ZBRA",
    "Description": "effectOfAccountingCharges",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ZBRA",
    "Description": "incomeBeforeTax",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ZBRA",
    "Description": "minorityInterest",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ZBRA",
    "Description": "netIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ZBRA",
    "Description": "sellingGeneralAdministrative",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ZBRA",
    "Description": "grossProfit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ZBRA",
    "Description": "ebit",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ZBRA",
    "Description": "operatingIncome",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ZBRA",
    "Description": "otherOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ZBRA",
    "Description": "interestExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ZBRA",
    "Description": "extraordinaryItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ZBRA",
    "Description": "nonRecurring",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ZBRA",
    "Description": "otherItems",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ZBRA",
    "Description": "incomeTaxExpense",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ZBRA",
    "Description": "totalRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ZBRA",
    "Description": "totalOperatingExpenses",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ZBRA",
    "Description": "costOfRevenue",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ZBRA",
    "Description": "totalOtherIncomeExpenseNet",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ZBRA",
    "Description": "discontinuedOperations",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ZBRA",
    "Description": "netIncomeFromContinuingOps",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  },
  {
    "Ticker": "ZBRA",
    "Description": "netIncomeApplicableToCommonShares",
    "Values": ["117M", "116M", "113M", "109M"],
    "2": null
  }
]
